// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownDivider_wrapper_3QEDe"};